module.exports = __webpack_public_path__ + "img/funnel-fdisp-aggiustata-2022.30dff7ce.svg";